import AscSubscriptionCenterContainer from './containers/AscSubscriptionCenterContainer'
import AscSubscriptionCenterDetailsContainer from './containers/AscSubscriptionCenterDetailsContainer'
import { role } from '@/utilities/userRoles'
import Index from './Index.vue'

const subscriptionCenterRouter = {
  path: '/user',
  meta: {},
  component: Index,
  children: [
    {
      path: 'subscription-center',
      name: 'Subscription Center',
      component: AscSubscriptionCenterContainer,
      meta: {
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Subscription Center',
          },
        ],
      },
    },
    {
      path: '/user/subscription-details/:groupName',
      name: 'Subscription Details',
      component: AscSubscriptionCenterDetailsContainer,
      meta: {
        requiresRole: [role.airlineUser, role.acmfUser],
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Subscription Center',
            to: '/user/subscription-center',
          },
          {
            dynamic: true,
            referenceParam: 'displayName',
            text: route =>
              ` ${
                route.params.displayName
                  ? route.params.displayName
                  : route.params.groupName.split('-').join(' ')
              }`,
          },
        ],
      },
      props: route => ({
        groupName: route.params.groupName,
      }),
    },
  ],
}

export default subscriptionCenterRouter
